import { useI18n } from '#/i18n/hooks/useI18n';
import { I18nLocale } from '#/i18n/types/I18nLocale';
import { ActionDateRange } from '#/modules/search/components/Facet/ActionDateRange';
import { LocaleFacet } from '#/modules/search/components/Facet/LocaleFacet';
import { LocationTypeFacet } from '#/modules/search/components/Facet/LocationTypeFacet';
import { OrgAreasOfFocusFacet } from '#/modules/search/components/Facet/OrgAreasOfFocusFacet';
import { RadiusFacet } from '#/modules/search/components/Facet/RadiusFacet';
import { RecencyFacet } from '#/modules/search/components/Facet/RecencyFacet';
import { SearchRefinements } from '#/modules/search/components/Refinements/SearchRefinements';
import type { VolopSource } from '#/utils/constants/general/volopSources';

import { DoneInADayFilter } from './DoneInADayFilter';
import { VolopKeywordsFacet } from './VolopKeywordsFacet';
import { VolopSourceFacet } from './VolopSourceFacet';
import { VolopWelcomeFacet } from './VolopWelcomeFacet';

type Props = {
  sourcesAllowed: VolopSource[];
};

export function SearchVolopsRefinements({ sourcesAllowed }: Props) {
  const { locale } = useI18n();

  return (
    <SearchRefinements
      listingType="VOLOP"
      renderFacets={({ variant }) => {
        switch (locale) {
          case I18nLocale.EN:
            return (
              <>
                <LocationTypeFacet variant={variant} />
                <OrgAreasOfFocusFacet variant={variant} />
                <VolopWelcomeFacet variant={variant} />
                <DoneInADayFilter variant={variant} />
                <VolopSourceFacet
                  variant={variant}
                  sourcesAllowed={sourcesAllowed}
                />
                <ActionDateRange variant={variant} />
                <VolopKeywordsFacet variant={variant} />
                <LocaleFacet variant={variant} />
                <RecencyFacet variant={variant} />
                <RadiusFacet variant={variant} />
              </>
            );

          case I18nLocale.ES:
            return (
              <>
                <LocaleFacet variant={variant} />
                <LocationTypeFacet variant={variant} />
                <OrgAreasOfFocusFacet variant={variant} />
                <VolopWelcomeFacet variant={variant} />
                <DoneInADayFilter variant={variant} />
                <VolopSourceFacet
                  sourcesAllowed={sourcesAllowed}
                  variant={variant}
                />
                <ActionDateRange variant={variant} />
                <VolopKeywordsFacet variant={variant} />
                <RecencyFacet variant={variant} />
                <RadiusFacet variant={variant} />
              </>
            );

          case I18nLocale.PT:
            return (
              <>
                <LocaleFacet variant={variant} />
                <LocationTypeFacet variant={variant} />
                <OrgAreasOfFocusFacet variant={variant} />
                <VolopWelcomeFacet variant={variant} />
                <DoneInADayFilter variant={variant} />
                <VolopSourceFacet
                  sourcesAllowed={sourcesAllowed}
                  variant={variant}
                />
                <ActionDateRange variant={variant} />
                <VolopKeywordsFacet variant={variant} />
                <RecencyFacet variant={variant} />
                <RadiusFacet variant={variant} />
              </>
            );
        }
      }}
    />
  );
}
